export const productDetailsQuery = `
  query quickViewProduct($productId: String!, $locale: String, $unifiedId: String!, $category: String!, $forcePcm: Boolean!) {
    productDetailPage(category: $category, unifiedId: $unifiedId, id: $productId, locale: $locale, forcePcm: $forcePcm) {
      productSummary {
        displayName
        pdpUrl
        isFinalSale
      }
      allSize {
        available
        size
      }
      productCarousel {
        color {
          code
          name
        }
        imageInfo
      }
      colorDriver {
        color
        sizes
      }
      variants {
        price {
          listPrice
          currency {
            code
            symbol
          }
          onSale
          salePrice
        }
        color {
          code
          name
          swatchUrl
          slug
        }
        imageSet {
          images {
            url
            alt
          }
          modelDescription
        }
      }
      skus {
        id
        styleId
        color {
          code
          name
          swatchUrl
          slug
        }
        size
        available
        inseam
        price {
          listPrice
          currency {
            code
            symbol
          }
          onSale
          salePrice
        }
      }
    }
  }
`;
